module.exports = __webpack_public_path__ + "img/CM-NL-24-Volkswagen-Modern.d1dfe38a.jpg";